package com.damda.design_system.core

import com.damda.design_system.data.ImageResult
import kotlinx.browser.window
import kotlinx.coroutines.await
import org.w3c.fetch.Response

actual class ImageResourceLoader {
    actual suspend fun loadImageResource(name: String): ImageResult {
        return try {
            val response: Response = window.fetch(name).await()
            if (!response.ok) {
                return ImageResult.Error("Failed to load image: ${response.statusText}")
            }
            val imageUrl = response.url // URL을 직접 반환
            ImageResult.Web(imageUrl)
        } catch (e: Exception) {
            ImageResult.Error("Error loading image: ${e.message}")
        }
    }
}